import { formatGBP } from '../../lib/money'

// RevenueBar — horizontal bar with label + value + percent (port of the
// v5 prototype's RevenueBar, lines 1714-1722). Used inside the Revenue
// Breakdown / Cost Breakdown cards on the FinancialsTab.
//
// value is pence (codebase money convention). pct is rendered to 1dp
// when fractional; the bar fill clamps to [0, 100].

interface RevenueBarProps {
  label: string
  valuePence: number
  pct: number
  last?: boolean
  colour?: 'green' | 'oxblood'
}

const COLOURS = {
  green: '#0a4a3a',
  oxblood: '#7a2329',
} as const

export function RevenueBar({ label, valuePence, pct, last, colour = 'green' }: RevenueBarProps) {
  const width = Math.max(0, Math.min(100, pct))
  const pctText = Math.abs(pct - Math.round(pct)) < 0.05 ? `${Math.round(pct)}%` : `${pct.toFixed(1)}%`
  return (
    <div className={last ? '' : 'mb-3.5'}>
      <div className="flex justify-between mb-1">
        <span className="text-sm font-semibold">{label}</span>
        <span className="text-sm font-mono">
          {formatGBP(valuePence)} <span className="text-ink-soft text-xs">· {pctText}</span>
        </span>
      </div>
      <div
        className="rounded-full overflow-hidden"
        style={{ height: 8, background: '#ece6db' }}
      >
        <div
          className="h-full rounded-full transition-[width] duration-500 ease-out"
          style={{ width: `${width}%`, background: COLOURS[colour] }}
        />
      </div>
    </div>
  )
}
